/* eslint-disable */
// @ts-nocheck
// source: internal/consultation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
var shared_types_interval_pb = require('../shared/types/interval_pb.js');
goog.object.extend(proto, shared_types_interval_pb);
goog.exportSymbol('proto.worklayer.internal.v1.BookConsultationRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BookConsultationResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.BookedConsultation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Consultation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Consultation.Availability', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Consultation.ConsultationStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.DownloadConsultationCalendarRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.DownloadConsultationCalendarResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListBookedConsultationsRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListBookedConsultationsResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetConsultationAvailabilityRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SetConsultationAvailabilityResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UnbookConsultationRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.UnbookConsultationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.displayName = 'proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.displayName = 'proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.SetConsultationAvailabilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.displayName = 'proto.worklayer.internal.v1.SetConsultationAvailabilityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListBookedConsultationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListBookedConsultationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListBookedConsultationsRequest.displayName = 'proto.worklayer.internal.v1.ListBookedConsultationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BookConsultationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.BookConsultationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BookConsultationRequest.displayName = 'proto.worklayer.internal.v1.BookConsultationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UnbookConsultationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UnbookConsultationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UnbookConsultationRequest.displayName = 'proto.worklayer.internal.v1.UnbookConsultationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.DownloadConsultationCalendarRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.displayName = 'proto.worklayer.internal.v1.DownloadConsultationCalendarRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListBookedConsultationsResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListBookedConsultationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListBookedConsultationsResponse.displayName = 'proto.worklayer.internal.v1.ListBookedConsultationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BookedConsultation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.BookedConsultation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BookedConsultation.displayName = 'proto.worklayer.internal.v1.BookedConsultation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SetConsultationAvailabilityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.displayName = 'proto.worklayer.internal.v1.SetConsultationAvailabilityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.BookConsultationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.BookConsultationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.BookConsultationResponse.displayName = 'proto.worklayer.internal.v1.BookConsultationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.UnbookConsultationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.UnbookConsultationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.UnbookConsultationResponse.displayName = 'proto.worklayer.internal.v1.UnbookConsultationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.DownloadConsultationCalendarResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.displayName = 'proto.worklayer.internal.v1.DownloadConsultationCalendarResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Consultation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Consultation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Consultation.displayName = 'proto.worklayer.internal.v1.Consultation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Consultation.Availability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Consultation.Availability.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Consultation.Availability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Consultation.Availability.displayName = 'proto.worklayer.internal.v1.Consultation.Availability';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    proId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest;
  return proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string pro_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.prototype.getProId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} returns this
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.prototype.setProId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} returns this
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bookedTimesList: jspb.Message.toObjectList(msg.getBookedTimesList(),
    shared_types_interval_pb.Interval.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse;
  return proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.addBookedTimes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBookedTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
};


/**
 * repeated worklayer.shared.types.v1.Interval booked_times = 1;
 * @return {!Array<!proto.worklayer.shared.types.v1.Interval>}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.prototype.getBookedTimesList = function() {
  return /** @type{!Array<!proto.worklayer.shared.types.v1.Interval>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_types_interval_pb.Interval, 1));
};


/**
 * @param {!Array<!proto.worklayer.shared.types.v1.Interval>} value
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse} returns this
*/
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.prototype.setBookedTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.shared.types.v1.Interval=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.prototype.addBookedTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.shared.types.v1.Interval, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse} returns this
 */
proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.prototype.clearBookedTimesList = function() {
  return this.setBookedTimesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    availabilityList: jspb.Message.toObjectList(msg.getAvailabilityList(),
    shared_types_interval_pb.Interval.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetConsultationAvailabilityRequest;
  return proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.addAvailability(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvailabilityList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} returns this
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated worklayer.shared.types.v1.Interval availability = 2;
 * @return {!Array<!proto.worklayer.shared.types.v1.Interval>}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.getAvailabilityList = function() {
  return /** @type{!Array<!proto.worklayer.shared.types.v1.Interval>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_types_interval_pb.Interval, 2));
};


/**
 * @param {!Array<!proto.worklayer.shared.types.v1.Interval>} value
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} returns this
*/
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.setAvailabilityList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.shared.types.v1.Interval=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.addAvailability = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.shared.types.v1.Interval, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} returns this
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityRequest.prototype.clearAvailabilityList = function() {
  return this.setAvailabilityList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListBookedConsultationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListBookedConsultationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedConsultationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListBookedConsultationsRequest}
 */
proto.worklayer.internal.v1.ListBookedConsultationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListBookedConsultationsRequest;
  return proto.worklayer.internal.v1.ListBookedConsultationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListBookedConsultationsRequest}
 */
proto.worklayer.internal.v1.ListBookedConsultationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListBookedConsultationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListBookedConsultationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedConsultationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BookConsultationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BookConsultationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BookConsultationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BookConsultationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bookedTime: (f = msg.getBookedTime()) && shared_types_interval_pb.Interval.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BookConsultationRequest}
 */
proto.worklayer.internal.v1.BookConsultationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BookConsultationRequest;
  return proto.worklayer.internal.v1.BookConsultationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BookConsultationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BookConsultationRequest}
 */
proto.worklayer.internal.v1.BookConsultationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.setBookedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BookConsultationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BookConsultationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BookConsultationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BookConsultationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBookedTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.BookConsultationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.BookConsultationRequest} returns this
 */
proto.worklayer.internal.v1.BookConsultationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional worklayer.shared.types.v1.Interval booked_time = 2;
 * @return {?proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.BookConsultationRequest.prototype.getBookedTime = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Interval} */ (
    jspb.Message.getWrapperField(this, shared_types_interval_pb.Interval, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Interval|undefined} value
 * @return {!proto.worklayer.internal.v1.BookConsultationRequest} returns this
*/
proto.worklayer.internal.v1.BookConsultationRequest.prototype.setBookedTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.BookConsultationRequest} returns this
 */
proto.worklayer.internal.v1.BookConsultationRequest.prototype.clearBookedTime = function() {
  return this.setBookedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.BookConsultationRequest.prototype.hasBookedTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UnbookConsultationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UnbookConsultationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UnbookConsultationRequest}
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UnbookConsultationRequest;
  return proto.worklayer.internal.v1.UnbookConsultationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UnbookConsultationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UnbookConsultationRequest}
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UnbookConsultationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UnbookConsultationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UnbookConsultationRequest} returns this
 */
proto.worklayer.internal.v1.UnbookConsultationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.DownloadConsultationCalendarRequest;
  return proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest} returns this
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListBookedConsultationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    appointmentsList: jspb.Message.toObjectList(msg.getAppointmentsList(),
    proto.worklayer.internal.v1.BookedConsultation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListBookedConsultationsResponse}
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListBookedConsultationsResponse;
  return proto.worklayer.internal.v1.ListBookedConsultationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListBookedConsultationsResponse}
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.BookedConsultation;
      reader.readMessage(value,proto.worklayer.internal.v1.BookedConsultation.deserializeBinaryFromReader);
      msg.addAppointments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListBookedConsultationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppointmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.BookedConsultation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BookedConsultation appointments = 1;
 * @return {!Array<!proto.worklayer.internal.v1.BookedConsultation>}
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.prototype.getAppointmentsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.BookedConsultation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.BookedConsultation, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.BookedConsultation>} value
 * @return {!proto.worklayer.internal.v1.ListBookedConsultationsResponse} returns this
*/
proto.worklayer.internal.v1.ListBookedConsultationsResponse.prototype.setAppointmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.BookedConsultation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.BookedConsultation}
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.prototype.addAppointments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.BookedConsultation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListBookedConsultationsResponse} returns this
 */
proto.worklayer.internal.v1.ListBookedConsultationsResponse.prototype.clearAppointmentsList = function() {
  return this.setAppointmentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BookedConsultation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BookedConsultation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BookedConsultation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bookedTime: (f = msg.getBookedTime()) && shared_types_interval_pb.Interval.toObject(includeInstance, f),
    clientPublicId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    proPublicId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BookedConsultation}
 */
proto.worklayer.internal.v1.BookedConsultation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BookedConsultation;
  return proto.worklayer.internal.v1.BookedConsultation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BookedConsultation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BookedConsultation}
 */
proto.worklayer.internal.v1.BookedConsultation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.setBookedTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientPublicId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BookedConsultation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BookedConsultation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BookedConsultation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBookedTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
  f = message.getClientPublicId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProPublicId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.BookedConsultation} returns this
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional worklayer.shared.types.v1.Interval booked_time = 2;
 * @return {?proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.getBookedTime = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Interval} */ (
    jspb.Message.getWrapperField(this, shared_types_interval_pb.Interval, 2));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Interval|undefined} value
 * @return {!proto.worklayer.internal.v1.BookedConsultation} returns this
*/
proto.worklayer.internal.v1.BookedConsultation.prototype.setBookedTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.BookedConsultation} returns this
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.clearBookedTime = function() {
  return this.setBookedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.hasBookedTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string client_public_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.getClientPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.BookedConsultation} returns this
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.setClientPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string pro_public_id = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.getProPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.BookedConsultation} returns this
 */
proto.worklayer.internal.v1.BookedConsultation.prototype.setProPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SetConsultationAvailabilityResponse;
  return proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse} returns this
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse} returns this
*/
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse} returns this
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.BookConsultationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.BookConsultationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.BookConsultationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BookConsultationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.BookConsultationResponse}
 */
proto.worklayer.internal.v1.BookConsultationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.BookConsultationResponse;
  return proto.worklayer.internal.v1.BookConsultationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.BookConsultationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.BookConsultationResponse}
 */
proto.worklayer.internal.v1.BookConsultationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.BookConsultationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.BookConsultationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.BookConsultationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.BookConsultationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.BookConsultationResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.BookConsultationResponse} returns this
 */
proto.worklayer.internal.v1.BookConsultationResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.BookConsultationResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.BookConsultationResponse} returns this
*/
proto.worklayer.internal.v1.BookConsultationResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.BookConsultationResponse} returns this
 */
proto.worklayer.internal.v1.BookConsultationResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.BookConsultationResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.UnbookConsultationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.UnbookConsultationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.UnbookConsultationResponse}
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.UnbookConsultationResponse;
  return proto.worklayer.internal.v1.UnbookConsultationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.UnbookConsultationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.UnbookConsultationResponse}
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.UnbookConsultationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.UnbookConsultationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.UnbookConsultationResponse} returns this
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.UnbookConsultationResponse} returns this
*/
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.UnbookConsultationResponse} returns this
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.UnbookConsultationResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.DownloadConsultationCalendarResponse;
  return proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse} returns this
 */
proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Consultation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Consultation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Consultation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Consultation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    availability: (f = msg.getAvailability()) && proto.worklayer.internal.v1.Consultation.Availability.toObject(includeInstance, f),
    clientUserPublicId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdByUserPublicId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    providerUserPublicId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    bookedTime: (f = msg.getBookedTime()) && shared_types_interval_pb.Interval.toObject(includeInstance, f),
    bookingCreateTime: (f = msg.getBookingCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 10, 0),
    requestedLength: (f = msg.getRequestedLength()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    skipScheduling: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    roomId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    wasBookedPreviously: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Consultation}
 */
proto.worklayer.internal.v1.Consultation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Consultation;
  return proto.worklayer.internal.v1.Consultation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Consultation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Consultation}
 */
proto.worklayer.internal.v1.Consultation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.Consultation.Availability;
      reader.readMessage(value,proto.worklayer.internal.v1.Consultation.Availability.deserializeBinaryFromReader);
      msg.setAvailability(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientUserPublicId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserPublicId(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderUserPublicId(value);
      break;
    case 8:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.setBookedTime(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBookingCreateTime(value);
      break;
    case 10:
      var value = /** @type {!proto.worklayer.internal.v1.Consultation.ConsultationStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 11:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setRequestedLength(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipScheduling(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWasBookedPreviously(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Consultation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Consultation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Consultation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Consultation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAvailability();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.Consultation.Availability.serializeBinaryToWriter
    );
  }
  f = message.getClientUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedByUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBookedTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
  f = message.getBookingCreateTime();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getRequestedLength();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getSkipScheduling();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getWasBookedPreviously();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Consultation.ConsultationStatus = {
  UNKNOWN: 0,
  PENDING_AVAILABILITY: 1,
  PENDING_BOOKING: 2,
  IN_PROGRESS: 3,
  DONE: 4,
  CANCELLED: 5,
  PENDING_CALL: 6,
  INCOMPLETE: 7
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Consultation.Availability.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Consultation.Availability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Consultation.Availability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Consultation.Availability.toObject = function(includeInstance, msg) {
  var f, obj = {
    availabilityTimesList: jspb.Message.toObjectList(msg.getAvailabilityTimesList(),
    shared_types_interval_pb.Interval.toObject, includeInstance),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Consultation.Availability}
 */
proto.worklayer.internal.v1.Consultation.Availability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Consultation.Availability;
  return proto.worklayer.internal.v1.Consultation.Availability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Consultation.Availability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Consultation.Availability}
 */
proto.worklayer.internal.v1.Consultation.Availability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.addAvailabilityTimes(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Consultation.Availability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Consultation.Availability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Consultation.Availability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailabilityTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated worklayer.shared.types.v1.Interval availability_times = 1;
 * @return {!Array<!proto.worklayer.shared.types.v1.Interval>}
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.getAvailabilityTimesList = function() {
  return /** @type{!Array<!proto.worklayer.shared.types.v1.Interval>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_types_interval_pb.Interval, 1));
};


/**
 * @param {!Array<!proto.worklayer.shared.types.v1.Interval>} value
 * @return {!proto.worklayer.internal.v1.Consultation.Availability} returns this
*/
proto.worklayer.internal.v1.Consultation.Availability.prototype.setAvailabilityTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.shared.types.v1.Interval=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.addAvailabilityTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.shared.types.v1.Interval, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Consultation.Availability} returns this
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.clearAvailabilityTimesList = function() {
  return this.setAvailabilityTimesList([]);
};


/**
 * optional google.protobuf.Timestamp create_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Consultation.Availability} returns this
*/
proto.worklayer.internal.v1.Consultation.Availability.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation.Availability} returns this
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.Availability.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Consultation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Consultation.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Availability availability = 3;
 * @return {?proto.worklayer.internal.v1.Consultation.Availability}
 */
proto.worklayer.internal.v1.Consultation.prototype.getAvailability = function() {
  return /** @type{?proto.worklayer.internal.v1.Consultation.Availability} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Consultation.Availability, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.Consultation.Availability|undefined} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
*/
proto.worklayer.internal.v1.Consultation.prototype.setAvailability = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.clearAvailability = function() {
  return this.setAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.hasAvailability = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string client_user_public_id = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.Consultation.prototype.getClientUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setClientUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string created_by_user_public_id = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.Consultation.prototype.getCreatedByUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setCreatedByUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp create_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Consultation.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
*/
proto.worklayer.internal.v1.Consultation.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string provider_user_public_id = 7;
 * @return {string}
 */
proto.worklayer.internal.v1.Consultation.prototype.getProviderUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setProviderUserPublicId = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.clearProviderUserPublicId = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.hasProviderUserPublicId = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional worklayer.shared.types.v1.Interval booked_time = 8;
 * @return {?proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.Consultation.prototype.getBookedTime = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Interval} */ (
    jspb.Message.getWrapperField(this, shared_types_interval_pb.Interval, 8));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Interval|undefined} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
*/
proto.worklayer.internal.v1.Consultation.prototype.setBookedTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.clearBookedTime = function() {
  return this.setBookedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.hasBookedTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp booking_create_time = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Consultation.prototype.getBookingCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
*/
proto.worklayer.internal.v1.Consultation.prototype.setBookingCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.clearBookingCreateTime = function() {
  return this.setBookingCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.hasBookingCreateTime = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ConsultationStatus status = 10;
 * @return {!proto.worklayer.internal.v1.Consultation.ConsultationStatus}
 */
proto.worklayer.internal.v1.Consultation.prototype.getStatus = function() {
  return /** @type {!proto.worklayer.internal.v1.Consultation.ConsultationStatus} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Consultation.ConsultationStatus} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional google.protobuf.Duration requested_length = 11;
 * @return {?proto.google.protobuf.Duration}
 */
proto.worklayer.internal.v1.Consultation.prototype.getRequestedLength = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 11));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
*/
proto.worklayer.internal.v1.Consultation.prototype.setRequestedLength = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.clearRequestedLength = function() {
  return this.setRequestedLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.hasRequestedLength = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool skip_scheduling = 12;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.getSkipScheduling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setSkipScheduling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string room_id = 13;
 * @return {string}
 */
proto.worklayer.internal.v1.Consultation.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setRoomId = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.clearRoomId = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.hasRoomId = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool was_booked_previously = 14;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Consultation.prototype.getWasBookedPreviously = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Consultation} returns this
 */
proto.worklayer.internal.v1.Consultation.prototype.setWasBookedPreviously = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


goog.object.extend(exports, proto.worklayer.internal.v1);
